import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import ImmutablePropTypes from 'react-immutable-proptypes';
import snakeCase from 'lodash.snakecase';
import { Popover } from '@saucelabs/sl-component-overlay';
import Button from '@saucelabs/sl-component-buttons';
import { ListGroup, ListGroupItem } from '@saucelabs/sl-component-list-group';

import Styles from './StatusPopover.styles';

const context = classNames.bind(Styles);

const StatusPopover = ({ clearStatuses, status, statusesIconMap, statusesList, toggleStatus }) => (
  <Popover
    id="filter-status-popover"
    placement="bottom"
  >
    <div className={Styles.default}>
      <div className={`label ${Styles.label}`}>
        <span>LIMIT RESULTS BY STATUS</span>
        <Button
          category="link"
          className={Styles['clear-button']}
          onClick={() => clearStatuses()}
          size="sm"
        >
          Clear Filters
        </Button>
      </div>
      <ListGroup className={Styles.list}>
        {statusesList.map((statusItem) => {
          const StatusIcon = statusesIconMap[snakeCase(statusItem)];
          return (
            <ListGroupItem
              key={statusItem}
              className={context(
                'item',
                { active: status.includes(statusItem.toLowerCase()) },
                snakeCase(statusItem),
              )}
              onClick={() => toggleStatus(statusItem.toLowerCase())}
            >
              <StatusIcon />
              <span>{statusItem}</span>
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </div>
  </Popover>
);

StatusPopover.propTypes = {
  clearStatuses: PropTypes.func.isRequired,
  status: ImmutablePropTypes.list.isRequired,
  statusesIconMap: PropTypes.object.isRequired,
  statusesList: PropTypes.array.isRequired,
  toggleStatus: PropTypes.func.isRequired,
};

export default StatusPopover;
